<template>
    <v-card :loading="form.busy || loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-tabs
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="company">
                Date companie
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="company">
                <v-card class="px-15 py-8" flat>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('name')"
                                :class="{ 'error--text': hasErrors('name') }"
                                class="primary--text"
                                name="name"
                                label="Denumire Comerciala"
                                data-vv-name="name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.name')"
                                :class="{ 'error--text': hasErrors('data.name') }"
                                class="primary--text"
                                name="data.name"
                                label="Denumire societate"
                                data-vv-name="data.name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.vat_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('vat_no')"
                                :class="{ 'error--text': hasErrors('vat_no') }"
                                class="primary--text"
                                name="vat_no"
                                label="CUI (Cod Unic de Identificare)"
                                data-vv-name="vat_no"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.trn"
                                v-validate="'required'"
                                :error-messages="errorMessages('trn')"
                                :class="{ 'error--text': hasErrors('trn') }"
                                class="primary--text"
                                name="trn"
                                label="Numarul Registrul Comertului"
                                data-vv-name="trn"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.county"
                                v-validate="'required'"
                                :error-messages="errorMessages('county')"
                                :class="{ 'error--text': hasErrors('county') }"
                                class="primary--text"
                                name="county"
                                label="Judet"
                                data-vv-name="county"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.city"
                                v-validate="'required'"
                                :error-messages="errorMessages('city')"
                                :class="{ 'error--text': hasErrors('city') }"
                                class="primary--text"
                                name="city"
                                label="Localitate"
                                data-vv-name="city"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.address"
                                v-validate="'required'"
                                :error-messages="errorMessages('address')"
                                :class="{ 'error--text': hasErrors('address') }"
                                class="primary--text"
                                name="address"
                                label="Adresa"
                                data-vv-name="address"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.data.address_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('address_no')"
                                :class="{ 'error--text': hasErrors('address_no') }"
                                class="primary--text"
                                name="address_no"
                                label="Numar/Apartament"
                                data-vv-name="address_no"
                                counter="255"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.rar_autorization"
                                v-validate="'required'"
                                :error-messages="errorMessages('rar_autorization')"
                                :class="{ 'error--text': hasErrors('rar_autorization') }"
                                class="primary--text"
                                name="rar_autorization"
                                label="Autorizatie RAR"
                                data-vv-name="rar_autorization"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.rar_code"
                                v-validate="'required'"
                                :error-messages="errorMessages('rar_code')"
                                :class="{ 'error--text': hasErrors('rar_code') }"
                                class="primary--text"
                                name="rar_code"
                                label="Cod atelier"
                                data-vv-name="rar_code"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.offer_prefix"
                                v-validate="'required'"
                                :error-messages="errorMessages('offer_prefix')"
                                :class="{ 'error--text': hasErrors('offer_prefix') }"
                                class="primary--text"
                                name="offer_prefix"
                                label="Serie oferta"
                                data-vv-name="offer_prefix"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.deviz_prefix"
                                v-validate="'required'"
                                :error-messages="errorMessages('deviz_prefix')"
                                :class="{ 'error--text': hasErrors('deviz_prefix') }"
                                class="primary--text"
                                name="deviz_prefix"
                                label="Serie deviz"
                                data-vv-name="deviz_prefix"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.service_responsible"
                                v-validate="'required'"
                                :error-messages="errorMessages('service_responsible')"
                                :class="{ 'error--text': hasErrors('service_responsible') }"
                                class="primary--text"
                                name="service_responsible"
                                label="Responsabil service"
                                data-vv-name="service_responsible"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.data.contact_sms"
                                v-validate="'required'"
                                :error-messages="errorMessages('contact_sms')"
                                :class="{ 'error--text': hasErrors('contact_sms') }"
                                class="primary--text"
                                name="contact_sms"
                                label="Date de contact SMS"
                                data-vv-name="contact_sms"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.bank_accounts"
                                v-validate="'required'"
                                :error-messages="errorMessages('bank_accounts')"
                                :class="{ 'error--text': hasErrors('bank_accounts') }"
                                class="primary--text"
                                name="bank_accounts"
                                label="Conturi bancare"
                                data-vv-name="bank_accounts"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.phone_numbers"
                                v-validate="'required'"
                                :error-messages="errorMessages('phone_numbers')"
                                :class="{ 'error--text': hasErrors('phone_numbers') }"
                                class="primary--text"
                                name="phone_numbers"
                                label="Numere de telefon"
                                data-vv-name="phone_numbers"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-textarea
                                v-model="form.data.email_addresses"
                                v-validate="'required'"
                                :error-messages="errorMessages('email_addresses')"
                                :class="{ 'error--text': hasErrors('email_addresses') }"
                                class="primary--text"
                                name="email_addresses"
                                label="Adrese de e-mail"
                                data-vv-name="email_addresses"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="form.data.conformity_declaration"
                                v-validate="'required'"
                                :error-messages="errorMessages('conformity_declaration')"
                                :class="{ 'error--text': hasErrors('conformity_declaration') }"
                                class="primary--text"
                                name="conformity_declaration"
                                label="Declaratie de conformitate"
                                data-vv-name="conformity_declaration"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="form.data.warranty"
                                v-validate="'required'"
                                :error-messages="errorMessages('warranty')"
                                :class="{ 'error--text': hasErrors('warranty') }"
                                class="primary--text"
                                name="warranty"
                                label="Certificat de garantie"
                                data-vv-name="warranty"
                            />
                        </v-col>
                    </v-row>
                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                data: {
                    name: null,
                    vat_no: null,
                    trn: null,
                    county: null,
                    city: null,
                    address: null,
                    address_no: null,
                    bank_accounts: null,
                    phone_numbers: null,
                    email_addresses: null,
                    rar_autorization: null,
                    rar_code: null,
                    conformity_declaration: null,
                    warranty: null,
                    offer_prefix: null,
                    deviz_prefix: null,
                    service_responsible: null,
                    contact_sms: null
                }
            }),
        }),
        async mounted() {
            await this.loadResources()
        },
        methods: {
            async loadResources() {
                let self = this;
                this.loading = true;

                if(this.id) {
                    let {data} = await this.$db.Workstation.find(this.id)
                    self.form = new Form(data)
                }
                setTimeout(() => this.loading = false, 1000)
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        let errors = this.errors.items.reduce((collect, error) => {
                            collect.push(...this.errorMessages(error.field))
                            return collect
                        }, [])
                        this.showError(`${errors.join("<br/>")}`)
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;


                /**
                 vatRates: this.vatRates,
                 paymentTypes: this.paymentTypes,
                 deliveryCities: this.deliveryCities
                 */

                Promise.all([
                    this.saveWorkstation()
                ])
                .then(response => {
                    self.$validator.reset();
                    this.showSuccess();
                    self.$nextTick(() => self.$router.push({name: "admin-configuration-index"}));
                })
                .catch(errors => {
                    let errorList = this.form.extractErrors(errors.response)
                    self.form.errors.set(errorList)
                    this.showError(`Salvarea datelor nu s-a efectuat in totalitate. Va rugam sa remediati urmatoarele erori: <br/>${Object.values(errorList).join('<br/>')}`)
                }).finally(async () => {
                    await this.loadResources()
                    self.form.busy = false;
                });
            },
            async saveWorkstation() {
                let model = new this.$db.Workstation(this.form);
                if (this.id) {
                    model.id = this.id
                }
                return model.save()
            }
        }
    };
</script>
